import MerchantTab from "./MerchantTab";
import StoreTab from "./StoreTab";
import ApplicationTab from "./ApplicationTab";
// import AccessTestTab from "./AccessTestTab";
import { SystemSettingTab } from "./SystemSettingTab";
// import MerchantQrTab from "./MerchantQrTab";
import { Tabs } from "@cloudscape-design/components-themed";
import { USER_TYPE } from "../../configs/constants";
import { useCanIShowHook } from "../../app/useCanIShowHook";

export const Tab = (props: any) => {
  const { companyCode } = props;
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);

  return isDocomoUser ? (
    <Tabs
      tabs={[
        {
          label: "加盟店",
          id: "first",
          content: (
            <MerchantTab
              companyCode={companyCode}
              isDocomoUser={isDocomoUser}
            />
          ),
        },
        {
          label: "店舗",
          id: "second",
          content: <StoreTab companyCode={companyCode} />,
        },
        {
          label: "申請事業者",
          id: "third",
          content: (
            <ApplicationTab
              corpInfo={props.corpInfo}
              groupData={props.groupData}
              companyType={props.companyType}
            />
          ),
        },
        // step1　不要
        // {
        //   label: "接続試験",
        //   id: "forth",
        //   content: (
        //     <AccessTestTab
        //       accessInfo={props.accessInfo}
        //       setAccessInfo={props.setAccessInfo}
        //       accessInfoErrorMsg={props.accessInfoErrorMsg}
        //       setAccessInfoErrorMsg={props.setAccessInfoErrorMsg}
        //       contractStyleItems={props.contractStyleItems}
        //       merchantNameItems={props.merchantNameItems}
        //     />
        //   ),
        // },
        {
          label: "システム設定",
          id: "fifth",
          content: <SystemSettingTab applicantCompanyCode={companyCode} />,
        },
        // step1　不要
        // {
        //   label: "加盟店QR",
        //   id: "sixth",
        //   content: <MerchantQrTab uploadData={props.uploadData} />,
        // },
      ]}
    />
  ) : (
    <Tabs
      tabs={[
        {
          label: "加盟店",
          id: "first",
          content: (
            <MerchantTab
              companyCode={companyCode}
              isDocomoUser={isDocomoUser}
            />
          ),
        },
        {
          label: "店舗",
          id: "second",
          content: <StoreTab companyCode={companyCode} />,
        },
        {
          label: "申請事業者",
          id: "third",
          content: (
            <ApplicationTab
              corpInfo={props.corpInfo}
              groupData={props.groupData}
            />
          ),
        },
        // step1不要
        // {
        //   label: "接続試験",
        //   id: "forth",
        //   content: (
        //     <AccessTestTab
        //       accessUploadData={props.accessUploadData}
        //       accessInfo={props.accessInfo}
        //       setAccessInfo={props.setAccessInfo}
        //       accessInfoErrorMsg={props.accessInfoErrorMsg}
        //       setAccessInfoErrorMsg={props.setAccessInfoErrorMsg}
        //       contractStyleItems={props.contractStyleItems}
        //       merchantNameItems={props.merchantNameItems}
        //     />
        //   ),
        // },
        // {
        //   label: "加盟店QR",
        //   id: "sixth",
        //   content: <MerchantQrTab uploadData={props.uploadData} />,
        // },
      ]}
    />
  );
};
